import api from '@/security/api'
import querystring from 'querystring'
import errorCatch from '@/helpers/errorCatch'

require('./../../security/interceptors')

const findAll = (objectQueryString) => {
    let query = querystring.stringify(objectQueryString)
    return api.get(`/companieschannels?${query}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar a listagem de canais')
        })
}

const find = (id) => {
    return api.get(`/companieschannels/${id}`)
        .then(response => {
            return response.data
        })
        .catch(error => {
            return errorCatch(error, 'Não foi possível carregar o canal')
        })
}

export default {
    findAll,
    find
}
